import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { ReactSortable } from 'react-sortablejs';
import styled from 'styled-components';
import { find } from 'lodash';

import { PHOTOS } from 'components/showcase/constants';

const Grid = styled(ReactSortable)`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  counter-reset: photo-number;
`;

const Counter = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1;

  padding: 4px;
  display: flex;
  justify-content: center;
  min-width: 20px;
  background: white;
  border-radius: 4px;

  color: var(--cc_color_text_default);
  font-weight: 600;
  font-size: 12px;
  line-height: 1;
`;

const SelectCounter = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 5;

  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 64px;

  color: white;
  font-weight: 700;
  font-size: 56px;
  line-height: 1;
`;

const Thumbnail = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  background-image: url(${(props) => props.path});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  border-radius: 4px;
  cursor: ${(props) => (props.isMovingSection ? 'pointer' : 'move')};

  &.moving {
    opacity: 50%;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  z-index: 2;

  ${Thumbnail}.selected & {
    background: linear-gradient(
      rgba(2, 119, 189, 0.75),
      rgba(2, 119, 189, 0.75)
    ) !important;
    background-size: cover;
  }
  ${Thumbnail}:hover & {
    transition: all ease-in-out 150ms;
    background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.7));
  }
`;

const SelectPhotos = ({
  isMovingSection,
  handleMultiSelect,
  selectedItems,
}) => {
  const renderThumbnail = (photo, idx) => {
    const isSelected = find(selectedItems, photo);
    const selectedIndex = selectedItems.indexOf(photo);

    return !isMovingSection ? (
      <Thumbnail
        key={photo.id}
        path={photo.data.reportPhoto.assetPreviewThumbnail}
      >
        <Counter>{idx + 1}</Counter>
      </Thumbnail>
    ) : (
      <Thumbnail
        key={photo.id}
        isMovingSection
        path={photo.data.reportPhoto.assetPreviewThumbnail}
        onClick={() => handleMultiSelect(photo)}
        className={isSelected ? 'selected' : ''}
      >
        {selectedIndex >= 0 && (
          <SelectCounter>{selectedIndex + 1}</SelectCounter>
        )}
        <Counter>{idx + 1}</Counter>
        <Overlay />
      </Thumbnail>
    );
  };

  return (
    <Field name={PHOTOS}>
      {(props) => {
        const {
          form: {
            values: { photos },
            setFieldValue,
          },
        } = props;

        const setList = (draggables) => {
          setFieldValue('photos', draggables);
        };

        return (
          <Grid
            animation={200}
            list={photos}
            setList={setList}
            disabled={isMovingSection}
          >
            {photos.map((photo, idx) => renderThumbnail(photo, idx))}
          </Grid>
        );
      }}
    </Field>
  );
};

SelectPhotos.propTypes = {
  form: PropTypes.object,
  isMovingSection: PropTypes.bool,
  handleMultiSelect: PropTypes.func,
  selectedItems: PropTypes.array,
};

export default SelectPhotos;
